import { isStatusError } from '@bonusly/http';

import { BadRequest } from './BadRequest';
import { Forbidden } from './Forbidden';
import { PageNotFound } from './PageNotFound';
import { ServerError } from './ServerError';
import { ServiceUnavailable } from './ServiceUnavailable';
import { Unauthorized } from './Unauthorized';
import { UnknownError } from './UnknownError';

export interface ErrorPageProps {
	error?: unknown;
}

export const ErrorPage = ({ error }: ErrorPageProps) => {
	const status = isStatusError(error) ? error.status : -1;

	switch (status) {
		case 400:
			return <BadRequest />;
		case 401:
			return <Unauthorized />;
		case 403:
			return <Forbidden />;
		case 404:
			return <PageNotFound />;
		case 500:
			return <ServerError />;
		case 503:
			return <ServiceUnavailable />;
		default:
			return <UnknownError />;
	}
};
